import { ConfigProvider as ThemeProvider } from 'antd';
import { Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import Loader from '~/common/components/utils/Loader.tsx';
import ChunkErrorBoundary from '~/common/errors/ChunkErrorBoundary.ts';
import { store } from '~/common/stores';

import '~/common/assets/styles/global.css';

import router from '~/routes';

function App() {
  return (
    <ReduxProvider store={store}>
      <ThemeProvider>
        <Suspense fallback={<Loader fullScreen />}>
          <ChunkErrorBoundary>
            <RouterProvider router={router} />
          </ChunkErrorBoundary>
        </Suspense>
      </ThemeProvider>
    </ReduxProvider>
  );
}

export default App;
